import * as React from "react";
import { Button, Glyphicon, Modal } from "react-bootstrap";
import ReactTable from "react-table";

export class ModalDetalleJson extends React.Component<ModalDetalleJsonProps, any> {

    columns = [{
        accessor: "parametro",
        className: "table-txt-left"
    },
    {
        accessor: "valor",
        Cell: props => (this.renderTexto(props)),
        className: "table-txt-left"
    }];

    constructor(props: any) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
            table: true
        };
    }

    handleShow() {
        this.setState({ show: true, detallesJson: this.convertirStringAJson(this.props.stringJson) });
    }

    handleClose() {
        this.setState({ show: false });
    }

    render() {
        return (
            <div>
                <a className={"btns btns-primary"} onClick={this.handleShow}>
                    <Glyphicon glyph={"file"} />
                </a>
                {this.state.show && this.renderModalDetalles()}
            </div>
        );
    }

    renderModalDetalles() {
        const { titulo } = this.props;
        return (
            <div>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{titulo ? titulo : ' '}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderContenido()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.handleClose}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    renderContenido = () => {
        return (
            <div>
                {this.renderTablaDetalles()}
            </div>
        );
    };

    renderTablaDetalles() {
        const datosDetalles = this.construirObjetoDetalles();
        const { subTitulo } = this.props;
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"} style={{ fontSize: `15px` }}>
                        {subTitulo}
                    </h2>
                </div>
                {
                    this.state.table &&
                    <ReactTable data={datosDetalles}
                        columns={this.columns}
                        sortable={false}
                        resizable={false}
                        showPagination={false}
                        className={"-highlight -striped"}
                        defaultPageSize={datosDetalles.length} />
                }
                {
                    !this.state.table &&
                    <div style={{ fontSize: '16px', marginTop: '16px' }}>
                        <b>Se ha presentado un error técnico:</b> <br /><br />
                        {datosDetalles}
                    </div>
                }
            </div>
        );
    }

    construirObjetoDetalles = () => {
        if (this.state.table) {
            const detalles = [];
            const { detallesJson } = this.state;
            const objetoDetalles = Object.keys(detallesJson);
            objetoDetalles.forEach(detalle => {
                detalles.push({
                    parametro: detalle,
                    valor: detallesJson[detalle]
                });
            });
            return detalles;
        } else {
            return this.state.detallesJson;
        }
    };

    convertirStringAJson(detalleGlosa: string) {
        try {
            return JSON.parse(detalleGlosa);
        } catch (e) {
            this.setState({ table: false });
            return detalleGlosa;
        }
    }

    renderTexto = (props: any) => {
        if (props.value || typeof props.value === 'boolean') {
            return (
                <span style={{
                    display: 'block',
                    width: '250px',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal'
                }}>{props.value.toString()}</span>
            );
        }
        return (props.value);
    }
}

interface ModalDetalleJsonProps {
    titulo: string,
    subTitulo: string,
    stringJson: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/ModalDetalleJson.tsx